<template>
  <div class="header-warpper">
    <h3 class="header-h3">社会组织人才考试系统</h3>
    <div class="header-set flex align-center">
      <div v-if="userRole" @click="toHome"><i class="iconfont iconqiehuan margin-right-xs"></i>切换帐号</div>
      <div @click="sginOut"><i class="iconfont iconpower margin-right-xs"></i>退出</div>
      <div><i class="iconfont iconguanliyuan margin-right-xs"></i>{{ region }}</div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";

export default {
  name: "headeMode",
  computed:{
    userRole(){
      return (store.state.token1 && store.state.token2)
    }
  },
  props:{
    region:{
      type:String
    }
  },
  methods:{
    toHome(){
      this.$router.push('/home')
    },
    sginOut(){
      this.$confirm('您确定要退出登录吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass:'msg-btn',
        confirmButtonClass:'msg-btn',
        center: true
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          router.push('/login')
          // location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style scoped lang="scss">
.header-warpper{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 30px;
  background: #222;
  .header-h3{
    font-size: 20px;
    color: #fff;
  }
  .header-set{
    div{
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      height: 50px;
      padding-right:30px;
      margin-right: 30px;
      cursor: pointer;
      border-right: 1px solid #ccc;
      &:last-child{
        border-right: 0;
      }
      &:hover{
        color: #009787;
      }
    }
  }
}
</style>
